import React from 'react';

import StatusIcon, { StatusIconType } from '../ui/icon/StatusIcon.component';
import Typography from '../ui/Typography.component';
import { Modal } from './Modal.component';
import { ModalButtonActionType } from './ModalButtonActionType.enum';

type StatusModalProps = {
	readonly modalId: string;
	readonly header?: string;
	readonly primaryButton?: any;
	readonly secondaryButton?: any;
	readonly dataqa?: string;
	readonly description?: string;
	readonly title?: string;
	readonly iconType?: StatusIconType;
	readonly onClose?: () => void;
};

export function StatusModal({
	modalId,
	header = '',
	title,
	primaryButton,
	secondaryButton,
	description,
	onClose,
	iconType,
	dataqa,
}: StatusModalProps) {
	return (
		<Modal
			modalId={modalId}
			header={header}
			primaryButton={
				primaryButton ?? {
					type: ModalButtonActionType.Ok,
					text: 'OK',
					onClick: onClose,
				}
			}
			secondaryButton={secondaryButton}
			dataqa={dataqa}
			className="status-modal"
		>
			<div className="status-modal-content">
				{iconType && (
					<div className="status-modal-icon">
						<StatusIcon type={iconType} />
					</div>
				)}
				<div>
					{title && (
						<Typography.H3 className="status-modal-header">
							{title}
						</Typography.H3>
					)}
					{description && <Typography.P>{description}</Typography.P>}
				</div>
			</div>
		</Modal>
	);
}
